import { render, staticRenderFns } from "./blockRight.vue?vue&type=template&id=6d48bab8&"
import script from "./blockRight.vue?vue&type=script&lang=js&"
export * from "./blockRight.vue?vue&type=script&lang=js&"
import style0 from "./blockRight.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports